<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="320">
      <v-card>
        <v-card-title class="text-h5">
          Validar transação
        </v-card-title>
        <v-card-text>
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="pin"
              :rules="pinRule"
              label="Digite o seu Pin"
              required
              filled
              placeholder="Valide a transação"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-gray darken-1" text @click="dialogClose">
            Fechar
          </v-btn>
          <v-btn color="green darken-1" text @click="sendMessage">
            Submeter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import eventBus from "../../../../main";
import convertToB64 from "../../../../../services/convertToB64";
export default {
  name: "PinConfirm",
  data: () => ({
    dialog: false,
    pin: "",
    valid: false,
    pinRule: [
      v => !!v || "Pin é obrigatório",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter"
    ]
  }),
  methods: {
    sendMessage() {
      if (this.$refs.form.validate()) {
        let encryptedPass = convertToB64.toRsa(this.pin);
        let payload = {
          pin: encryptedPass
        };
        this.$store.dispatch("checkConnection", payload);
      }
      return false;
    },
    dialogClose() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog = false;
    }
  },
  created() {
    const self = this;
    eventBus.$on("pinConfirm", function(payload) {
      self.dialog = payload;
    });
  }
};
</script>

<style scoped></style>
